export default "__VITE_ASSET__BPCTf1$w__"